import {useContext, useState} from 'react';
import { LayerBorderForm } from './LayerBorderForm';
import { LayerIconForm } from './LayerIconForm';
import { LayerTextForm } from './LayerTextForm';
import { LayerOutlineForm } from './LayerOutlineForm';
import {EntityContext} from "#src/context/EntityContext";
import {XplanStylerContext} from "#src/context/XplanStylerContext";
import bg from "#src/assets/styler.jpg";

export const PolygonForm = () => {

    const {activeConfig, newConfig, setNewConfig} = useContext(XplanStylerContext);


    if(typeof activeConfig !== "undefined" && activeConfig !== null) {
        const layerConfig = activeConfig?.visualisation;
        var icon = null;
        var baseBackgroundPattern = null;


        if (typeof layerConfig?.baseBackgroundPattern?.icon !== "undefined") {
            baseBackgroundPattern =  require('../../../assets/icons/'+layerConfig?.baseBackgroundPattern?.icon+'.png');
        }

        if (typeof layerConfig?.overlayIcon?.icon !== "undefined") {
            icon =  require('../../../assets/icons/'+layerConfig?.overlayIcon?.icon+'.png');
        }


        return (
            <div className='flex flex-col'>
                <div className="threeDimaOnHover w-[300px] h-[300px]  border-gray-400 border  flex items-center justify-center">



                    {/* baseLayer Background */}



                    {(baseBackgroundPattern !== null) ? (
                        <div  className="layer4  rotate-45   absolute flex items-center justify-center rounded-md" style={{
                            backgroundImage: 'url('+baseBackgroundPattern+')',
                            width: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2 )+"px" : "150px",
                            height: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2  )+"px" : "150px",
                        }} alt="pattern" ></div>
                    ) : (
                        <div className="layer1 bg-white rotate-45  absolute flex items-center justify-center rounded-md" style={
                            {
                                width: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2 )+"px" : "150px",
                                height: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2  )+"px" : "150px",
                                margin: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  "-"+layerConfig?.baseBorder?.borderOffset+"px" : "0px",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                                borderBottomRightRadius: "8px",
                                borderBottomLeftRadius: "8px",
                                backgroundColor: (typeof layerConfig?.baseBackground?.backgroundColor !== "undefined") ? layerConfig?.baseBackground?.backgroundColor : "#fff",
                                opacity: (typeof layerConfig?.baseBackground?.backgroundOpacity !== "undefined") ? layerConfig?.baseBackground?.backgroundOpacity : 1
                            }
                        } >
                        </div>
                    )}






                    {/* baseLayer Border */}
                    <div className="layer2  rotate-45  absolute flex items-center justify-center rounded-md" style={
                        {
                            width: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2 )+"px" : "150px",
                            height: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  (150 + ((layerConfig?.baseBorder?.borderOffset)) * 2  )+"px" : "150px",
                            margin: (typeof layerConfig?.baseBorder?.borderOffset !== "undefined") ?  "-"+layerConfig?.baseBorder?.borderOffset+"px" : "0px",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            borderWidth: (typeof layerConfig?.baseBorder?.borderSize !== "undefined") ? layerConfig?.baseBorder?.borderSize+"pt" : "0pt",
                            borderColor: (typeof layerConfig?.baseBorder?.borderColor !== "undefined") ? layerConfig?.baseBorder?.borderColor : "#000",
                            borderTopLeft: "0px",
                            borderStyle: (typeof layerConfig?.baseBorder?.borderDashArray !== "undefined") ? "dashed" : "solid",
                            opacity: (typeof layerConfig?.baseBackground?.borderOpacity !== "undefined") ? layerConfig?.baseBackground?.borderOpacity : 1
                        }
                    } >
                    <div className={"layer4 ml-6  rounded-full flex items-center justify-center"} style={{width:40+"px", height:40+"px"}}></div>

                        {(typeof layerConfig?.basesText?.text !== "undefined") && (
                            <div className={"layer4 w-[50px] -mb-12 -ml-6 -rotate-45 h-[50px]rounded-md items-center flex justify-center rounded-md"} style={
                                {
                                    color: (typeof layerConfig?.basesText?.textColor !== "undefined") ? layerConfig?.basesText?.textColor : "#000",
                                    fontSize: (typeof layerConfig?.basesText?.textSize !== "undefined") ? layerConfig?.basesText?.textSize+"px" : "12px",
                                    textShadow: (typeof layerConfig?.basesText?.textShadowColor !== "undefined") ? "2px 2px 10px "+ layerConfig?.basesText?.textShadowColor : "none",
                                }
                            }>
                                Aufschrift
                            </div>
                        )}




                        {(icon !== null) && (
                            <img  className="layer4  -rotate-45  absolute flex items-center justify-center rounded-md" src={icon} alt="icon" />
                        )}


                </div>

                {/*
                <div className='flex flex-col border-gray-500  border-t p-4 mb-4'>
                    <h2 className='text-lg font-bold'>Umrandung</h2>
                    <LayerBorderForm layerStyle={layerConfig} setLayerStyle={layerConfig} />
                </div>
                <div className='flex flex-col border-gray-500  border-t p-4 mb-4'>
                    <h2 className='text-lg font-bold'>Außen- / Innenumrandung</h2>
                    <LayerOutlineForm layerStyle={layerConfig} setLayerStyle={layerConfig} />
                </div>
                <div className='flex flex-col border-gray-500  border-t p-4 mb-4'>
                    <h2 className='text-lg font-bold'>Icon</h2>
                    <LayerIconForm layerStyle={layerConfig} setLayerStyle={layerConfig} />
                </div>
                <div className='flex flex-col border-gray-500  border-t p-4 mb-4'>
                    <h2 className='text-lg font-bold'>Aufschrift</h2>
                    <LayerTextForm layerStyle={layerConfig} setLayerStyle={layerConfig} />
                </div>*/}
            </div>
            </div>
        )
    }
}